import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.5 9.5a2.5 2.5 0 0 0 3.535 0l2-2a2.5 2.5 0 0 0-3.535-3.535l-.5.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.5 6.5a2.5 2.5 0 0 0-3.535 0l-2 2a2.5 2.5 0 0 0 3.535 3.535l.5-.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
